// Sentence Puzzles — scrambled sentences the learner must reorder.
// Curated for teen/adult learners: everyday, meaningful sentences.
export const SENTENCE_PUZZLES = [
  { id: "sp-1", words: ["The", "ancient", "library", "holds", "many", "secrets"] },
  { id: "sp-2", words: ["Reading", "opens", "doors", "to", "new", "worlds"] },
  { id: "sp-3", words: ["Practice", "every", "day", "for", "real", "progress"] },
  { id: "sp-4", words: ["A", "quiet", "mind", "learns", "faster"] },
  { id: "sp-5", words: ["She", "climbed", "the", "steep", "mountain", "alone"] },
  { id: "sp-6", words: ["Curiosity", "is", "the", "engine", "of", "learning"] },
  { id: "sp-7", words: ["The", "old", "bookshop", "smelled", "of", "paper"] },
  { id: "sp-8", words: ["Kindness", "costs", "nothing", "but", "means", "everything"] },
  { id: "sp-9", words: ["Every", "word", "you", "learn", "is", "a", "small", "victory"] },
  { id: "sp-10", words: ["The", "river", "carried", "the", "boat", "gently", "downstream"] },
];
